// import React, { useContext } from "react";
// import { useState, useEffect } from "react";
// import Select from "react-select";
// import { Table, Button, Form, Pagination } from "react-bootstrap";
// import { Context } from "../../../../utils/context";
// import { getDownloadDataExcel, postData } from "../../../../utils/api";
// import { Link } from "react-router-dom";
// import {
//   formatDate,
//   formatTo12Hour,
//   IDS,
//   OrderStatusIds,
//   ReturnStatusIds,
//   RoleId,
//   ServiceIds,
// } from "../../../../utils/common";
// import AssignOffCanvance from "../AssignDeliveryBoy";
// import ProductModal from "../ProductModal";
// import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";
// import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
// import DatePicker from "react-datepicker";
// import search1 from "../../../assets/icons/search.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { ClipLoader } from "react-spinners";

// function CancelledTable({
//   user,
//   OrderByOptions,

//   storeCategories,

//   productCategories,

//   vendorServices,
//   resultsPerPageOptions,
// }) {
//   const {
//     getData,
//     editStatusData,
//     deleteData,
//     ErrorNotify,
//     isAllow,
//     Per_Page_Dropdown,
//     Select2Data,
//     usertype,
//     IMG_URL,
//   } = useContext(Context);

//   const [perPage, setperPage] = useState({
//     value: 25,
//     label: "Results per page: 25",
//   });

//   const [data, setData] = useState([]);
//   const [totalPages, settotalPages] = useState();
//   const [onPageChange, setonPageChange] = useState(1);

//   const [reset, setReset] = useState();
//   const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [option, setOption] = useState();

//   const [loader, setLoader] = useState("");

//   const [storeCategory, setStoreCategory] = useState("");
//   const [productCategory, setProductCategory] = useState("");
//   const [search, setSearch] = useState("");
//   const [searchCustomer, setSearchCustomer] = useState("");

//   const [searchDateTo, setSearchDateTo] = useState();
//   const [searchDateFrom, setSearchDateFrom] = useState();

//   const [searchStartTime, setSearchStartTime] = useState();
//   const [searchEndTime, setSearchEndTime] = useState();
//   const [sortOrder, setSortOrder] = useState({
//     value: "DESC",
//     label: "Sort-by date (Descending)",
//   });
//   const [searchCustomerContact, setSearchCustomerContact] = useState("");
//   const getDataAll = async () => {
//     setLoader(true);

//     const response = await getData(
//       `/admin/orders/cancel-order?page=${onPageChange || 1}&per_page=${
//         perPage?.value || 25
//       }&term=${search}&searchOrderStatus=${
//         OrderStatusIds.Rejected || ""
//       }&productCategory=${
//         productCategory.value || ""
//       }&sortOrder=${sortOrder?.value || "DESC"}&from=${
//         searchDateFrom || ""
//       }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
//         searchEndTime || ""
//       }&name=${search || ""}&customer=${searchCustomer || ""}&customer_contact=${searchCustomerContact || ""}`,
//     );
//     await setData(response);
//     setCurrentPage(response?.data?.current_page);
//     // setperPage(response?.data?.per_page);
//     settotalPages(response?.data?.total_pages);
//     setSearch(response?.data?.search_name);
//     setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
//     // await GetAllCounts();

//     setLoader(false);
//   };
//   useEffect(() => {
//     getDataAll();
//   }, [reset, searchOrderStatus, productCategory, onPageChange]);

//   const handlePageChange = (pageNumber) => {
//     setonPageChange(pageNumber);
//   };

//   const paginationItems = [];
//   for (let page = 1; page <= totalPages; page++) {
//     paginationItems.push(
//       <Pagination.Item
//         key={page}
//         active={page === onPageChange}
//         onClick={() => handlePageChange(page)}
//       >
//         {page}
//       </Pagination.Item>,
//     );
//   }

//   const [showAssign, setShowAssign] = useState({ show: 0, data: {} });
//   const [showReturnAssign, setShowReturnAssign] = useState({
//     show: 0,
//     data: {},
//   });
//   const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

//   const calculateTimeAgo = (date) => {
//     const createdAt = new Date(date);
//     const now = new Date();
//     const diffInMilliseconds = now - createdAt;

//     const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
//     const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
//     const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

//     if (diffInDays >= 1) {
//       return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
//     } else if (diffInHours >= 1) {
//       return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
//     } else {
//       return `${diffInMinutes} Min Ago`;
//     }
//   };

//   const formatTimeInIST = (date) => {
//     const createdAt = new Date(date);
//     const options = { hour: "2-digit", minute: "2-digit", hour12: true };
//     const istTime = createdAt.toLocaleString("en-IN", {
//       timeZone: "Asia/Kolkata",
//       ...options,
//     });
//     // setFormattedTime(`${istTime} IST`);
//     return istTime;
//   };

//   const ChangeOrderStatus = async (id, status_id) => {
//     try {
//       // Send the POST request to update the store's status
//       await postData(`/admin/orders/product-order/update-status/${id}`, {
//         order_status_id: status_id,
//       });

//       // Refresh the data after updating the store's status
//       await getDataAll();
//     } catch (error) {
//       console.error("Error updating store status:", error);
//     }
//   };

//   const downloadInvoice = async (invoiceUrl) => {
//     try {
//       const response = await fetch(invoiceUrl);
//       const blob = await response.blob();

//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");

//       link.href = url;
//       link.download = "invoice.pdf"; // Set your preferred filename
//       link.click();

//       window.URL.revokeObjectURL(url);
//     } catch (error) {
//       console.error("Download error:", error);
//     }
//   };

//   const HandleDownload = async () => {
//     if (data?.data?.data?.length <= 0) {
//       alert("No record found");
//     } else {
//       try {
//         // await DownloadExcel(
//         //   // "/download-excel/download-users",
//         //   `/download-excel/download-users?term=${search || ""}&mobile=${mobile || ""}&from=${from || ""}&to=${to || ""}`,
//         //   "Users List"
//         // );
//         await getDownloadDataExcel(
//           `/admin/orders/download?page=${onPageChange || 1}&per_page=${
//             perPage?.value || 25
//           }&term=${search}&searchOrderStatus=${
//             OrderStatusIds.Rejected || ""
//           }&storeCategory=${storeCategory}&productCategory=${
//             productCategory || ""
//           }&sortOrder=${sortOrder?.value || "DESC"}&from=${
//             searchDateFrom || ""
//           }&to=${searchDateTo || ""}&start_time=${
//             searchStartTime || ""
//           }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
//             searchCustomer || ""
//           }`,
//           null,
//           "Subscription Order List",
//         );
//       } catch (error) {
//         console.error("Error:", error);
//       }
//     }
//   };
//   return (
//     <section className="pending-table_holder">
//       {/* Quick Filters Section */}
//       <div className="quick-filters mt-3">
//         <span className="quick-filters__label">
//           <b>Quick Filters:</b>
//         </span>
//         <div className="quick-filters__tabs mt-3">
//           <div className="row align-items-end">
//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <div className="num me-2">
//                 <label className="form-label">Start Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   placeholder="from"
//                   value={searchDateFrom}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     const year = value.split("-")[0];

//                     // Check if year has 4 digits
//                     if (year.length === 4 || value === "") {
//                       setSearchDateFrom(value);
//                       setonPageChange(1);
//                     }
//                   }}
//                 />
//               </div>
//             </div>

//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <div className="num me-2">
//                 <label className="form-label">End Date</label>
//                 <input
//                   type="date"
//                   className="form-control"
//                   placeholder="to"
//                   value={searchDateTo}
//                   min={searchDateFrom || undefined}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     const year = value.split("-")[0];

//                     // Allow only if year is 4 digits or input is empty
//                     if (year.length === 4 || value === "") {
//                       setSearchDateTo(value);
//                       setonPageChange(1);
//                     }
//                   }}
//                 />
//               </div>
//             </div>

//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <Form.Label>Product Name</Form.Label>
//               <Form.Control
//                 placeholder="Enter Product Name"
//                 type="text"
//                 className="form-control"
//                 id=""
//                 value={search}
//                 onChange={(e) => {
//                   setSearch(e.target.value);
//                 }}
//               />
//             </div>
//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <Form.Label>Customer Name</Form.Label>
//               <Form.Control
//                 placeholder="Enter Customer Name"
//                 type="text"
//                 className="form-control"
//                 id=""
//                 value={searchCustomer}
//                 onChange={(e) => {
//                   setSearchCustomer(e.target.value);
//                 }}
//               />
//             </div>
//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
//               <Form.Label>Customer Contact No</Form.Label>
//               <Form.Control
//                 placeholder="Enter Customer Contact No"
//                 type="text"
//                 className="form-control"
//                 id=""
//                 value={searchCustomerContact}
//                 onChange={(e) => {
//                   setSearchCustomerContact(e.target.value);
//                 }}
//               />
//             </div>
//             <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
//               <div className="Search me-2">
//                 <Button
//                   type="button"
//                   onClick={getDataAll}
//                   className="btn btn-search"
//                 >
//                   <img src={search1} className="search" alt="" />
//                 </Button>
//               </div>
//               <div className="Search-1">
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setSearch("");
//                     setSearchDateFrom("");
//                     setSearchDateTo("");
//                     setSearchEndTime("");
//                     setSearchStartTime("");
//                     setSearchCustomer("");
//                     setSearchCustomerContact("");
//                     setReset(!reset);
//                   }}
//                   className="btn btn-reset"
//                 >
//                   Reset
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Table Section */}

//       {loader ? (
//         <>
//           <div className="text-center">
//             <ClipLoader />
//           </div>
//         </>
//       ) : (
//         <div className="pending-table ">
//           <Table striped bordered hover className="order-table" responsive>
//             <thead>
//               <tr>
//                 <th>Order Date</th>
//                 <th>Order details</th>

//                 <th>Products</th>
//                 <th>Total</th>
//                 <th>Delivery Details</th>
//                 <th>Order Status</th>
//                 {/* <th>Action</th> */}
//               </tr>
//             </thead>
//             <tbody>
//               {data?.data?.data?.map((item, index) => (
//                 <tr key={index}>
//                   <td className="order-date">
//                     <div className="order-id">
//                       {calculateTimeAgo(item?.createdAt)}
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         {new Date(item?.createdAt).toISOString().split("T")[0]}
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span>{formatTimeInIST(item?.createdAt)} IST</span>
//                     </div>
//                   </td>

//                   {/* Owner Details */}
//                   <td className="order-details">
//                     <div className="order-id text-highlight">
//                       {item?.Product_Order?.invoice_no}
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         <b>Buyer Name</b>
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span className="text-highlight">
//                         {item?.Product_Order?.User?.name}
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span className="order-info">
//                         {item?.Product_Order?.User?.contact_no}
//                       </span>
//                     </div>

//                     <div className="order-info">
//                       <span>{item?.Product_Order?.Payment_Type?.name}</span>
//                     </div>

//                     {/* <div className="order-info">
//                     <span>{item?.user?.type}</span>
//                   </div> */}
//                   </td>

//                   <td className="order-details">
//                     {/* {item?.Product_Order_Details?.map((product) => ( */}
//                     <React.Fragment key={item.id}>
//                       <div className="text-highlight">
//                         <strong>Product {index + 1}</strong>
//                       </div>

//                       <div className="text-highlight">
//                         <span>
//                           <b>Product Name</b>
//                         </span>
//                         :<span>{item?.Product?.name}</span>
//                       </div>
//                       <div className="order-info">
//                         <span>
//                           <b>Category Name</b>
//                         </span>
//                         :<span>{item?.Product?.p_category?.name} </span>
//                       </div>
//                     </React.Fragment>
//                     {/* ))} */}
//                     <div></div>
//                     {/* <div className=" mt-3">
//                     <Button
//                       className="action-btn active"
//                       onClick={() =>
//                         setShowDetails({
//                           show: item?.id,
//                           data: item?.Product_Order_Details,
//                         })
//                       }
//                     >
//                       View All Details
//                     </Button>
//                   </div> */}
//                   </td>

//                   <td className="order-details">
//                     <div className="order-id">
//                       <span>
//                         <b>Total SubTotal</b>
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         {item.Exchange_Rate?.symbol || "₹"}{" "}
//                         {Number(item?.total_selling_price).toFixed(2)} /-
//                       </span>
//                     </div>
//                     {/* <div className="order-id">
//                     <span>Packing Charges</span>
//                   </div>
//                   <div className="order-info">
//                     <span>{item?.packing_charges} /-</span>
//                   </div> */}
//                     <div className="order-id">
//                       <span>
//                         <b>Delivery Charges</b>
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         {item.Exchange_Rate?.symbol || "₹"}{" "}
//                         {Number(item?.delivery_charges).toFixed(2)} /-
//                       </span>
//                     </div>
//                     {/* <div className="order-id">
//                     <span>
//                       <b>Offer Discount</b>
//                     </span>
//                   </div>
//                   <div className="order-info">
//                     <span>{item.Exchange_Rate?.symbol || "₹"}{" "}{Number(item?.offer_discount).toFixed(2)} /-</span>
//                   </div> */}
//                     <div className="order-id">
//                       <span>
//                         <b>Coupon Discount</b>
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         {item.Exchange_Rate?.symbol || "₹"}{" "}
//                         {Number(item?.coupon_discount).toFixed(2)} /-
//                       </span>
//                     </div>
//                     <div className="order-id">
//                       <span>
//                         <b>Total Tax</b>
//                       </span>
//                     </div>
//                     <div className="order-info">
//                       <span>
//                         {item.Exchange_Rate?.symbol || "₹"}{" "}
//                         {Number(item?.total_tax).toFixed(2)} /-
//                       </span>
//                     </div>
//                     <div className="order-id">
//                       <span>
//                         <b>Grand Total</b>
//                       </span>
//                     </div>
//                     <div className="text-highlight">
//                       <span>
//                         {item.Exchange_Rate?.symbol || "₹"}{" "}
//                         {Number(item?.total_amount).toFixed(2)} /-
//                       </span>
//                     </div>
//                   </td>

//                   <td>
//                     <>
//                       <div className="text-highlight">
//                         <span>
//                           {[
//                             item?.Product_Order?.User_Address?.first_name,
//                             item?.Product_Order?.User_Address?.last_name,
//                           ]
//                             .filter(Boolean)
//                             .join(" ")}
//                         </span>
//                       </div>

//                       <div className="order-info">
//                         <span>
//                           {[
//                             item?.Product_Order?.User_Address?.floor
//                               ? `${item.Product_Order.User_Address.floor} floor`
//                               : null,
//                             item?.Product_Order?.User_Address?.building,
//                             item?.Product_Order?.User_Address?.apartment,
//                             item?.Product_Order?.User_Address?.street,
//                             item?.Product_Order?.User_Address?.society,
//                             item?.Product_Order?.User_Address?.area,
//                           ]
//                             .filter(Boolean)
//                             .join(", ")}
//                         </span>
//                       </div>

//                       <div className="order-info">
//                         <span>
//                           {[
//                             item?.Product_Order?.User_Address
//                               ?.Users_Address_Detail?.Country?.name,
//                             item?.Product_Order?.User_Address
//                               ?.Users_Address_Detail?.State?.name,
//                             item?.Product_Order?.User_Address
//                               ?.Users_Address_Detail?.City?.name,
//                             item?.Product_Order?.User_Address
//                               ?.Users_Address_Detail?.Area?.name,
//                             item?.Product_Order?.User_Address
//                               ?.Users_Address_Detail?.Pincode?.name,
//                           ]
//                             .filter(Boolean)
//                             .join(", ")}
//                         </span>
//                       </div>

//                       {item?.Product_Order?.User_Address?.address_type && (
//                         <div className="order-info">
//                           <span>
//                             {item.Product_Order.User_Address.address_type}
//                           </span>
//                         </div>
//                       )}

//                       {item?.Product_Order?.User_Address?.contact_no && (
//                         <div className="text-highlight">
//                           <span>
//                             {item.Product_Order.User_Address.contact_no}
//                           </span>
//                         </div>
//                       )}

//                       <div className="order-info">
//                         <span>
//                           <b>Cancel Message</b>
//                         </span>{" "}
//                         :{" "}
//                         <span>
//                           {item?.Product_Order?.Order_Cancellation?.message}
//                         </span>
//                       </div>
//                       <div className="text-highlight">
//                         <span>
//                           <b>Cancel Reason</b>
//                         </span>{" "}
//                         :
//                         <span>
//                           {
//                             item?.Product_Order?.Order_Cancellation
//                               ?.Cancel_Reason?.name
//                           }{" "}
//                         </span>
//                       </div>
//                     </>
//                   </td>

//                   <td>
//                     <div>
//                       <p className="status-holder Unshipped">Rejected</p>
//                     </div>
//                     {/* {item?.order_status_id === 4 ? (
//                     <div>
//                       <p className="status-holder shipped">
//                         {item?.Order_status?.name}
//                       </p>
//                     </div>
//                   ) : (

//                   )} */}

//                     {item?.Order_History?.delivery_boy_assigned && (
//                       <div className="order-info">
//                         Delivery Boy Asigned At
//                         <div className="order-info">
//                           <span>
//                             {
//                               new Date(
//                                 item?.Order_History?.delivery_boy_assigned,
//                               )
//                                 .toISOString()
//                                 .split("T")[0]
//                             }
//                             {formatTimeInIST(
//                               item?.Order_History?.delivery_boy_assigned,
//                             )}{" "}
//                             IST
//                           </span>
//                         </div>
//                       </div>
//                     )}

//                     {item?.Order_History?.out_for_delivery && (
//                       <div className="order-info">
//                         Out For Delivery At
//                         <div className="order-info">
//                           <span>
//                             {
//                               new Date(item?.Order_History?.out_for_delivery)
//                                 .toISOString()
//                                 .split("T")[0]
//                             }
//                             {formatTimeInIST(
//                               item?.Order_History?.out_for_delivery,
//                             )}{" "}
//                             IST
//                           </span>
//                         </div>
//                       </div>
//                     )}

//                     {/* {item?.Order_History?.cancelledAt && ( */}
//                     <div className="order-info">
//                       Cancelled At
//                       <div className="order-info">
//                         <span>
//                           {
//                             new Date(item?.updatedAt)
//                               .toISOString()
//                               .split("T")[0]
//                           }{" "}
//                           <br />
//                           {formatTimeInIST(item?.updatedAt)} IST
//                         </span>
//                       </div>
//                     </div>
//                     {/* )} */}

//                     {item?.Order_History?.returnRequestedAt && (
//                       <div className="order-info">
//                         Return Requested At
//                         <div className="order-info">
//                           <span>
//                             {
//                               new Date(item?.Order_History?.returnRequestedAt)
//                                 .toISOString()
//                                 .split("T")[0]
//                             }
//                             {formatTimeInIST(
//                               item?.Order_History?.returnRequestedAt,
//                             )}{" "}
//                             IST
//                           </span>
//                         </div>
//                       </div>
//                     )}

//                     {item?.Order_History?.returnScheduledAt && (
//                       <div className="order-info">
//                         Return Scheduled At
//                         <div className="order-info">
//                           <span>
//                             {
//                               new Date(item?.Order_History?.returnScheduledAt)
//                                 .toISOString()
//                                 .split("T")[0]
//                             }
//                             {formatTimeInIST(
//                               item?.Order_History?.returnScheduledAt,
//                             )}{" "}
//                             IST
//                           </span>
//                         </div>
//                       </div>
//                     )}

//                     {item?.Order_History?.itemPickedAt && (
//                       <div className="order-info">
//                         Item Picked At
//                         <div className="order-info">
//                           <span>
//                             {
//                               new Date(item?.Order_History?.itemPickedAt)
//                                 .toISOString()
//                                 .split("T")[0]
//                             }
//                             {formatTimeInIST(item?.Order_History?.itemPickedAt)}{" "}
//                             IST
//                           </span>
//                         </div>
//                       </div>
//                     )}

//                     {item?.Order_History?.returnedAt && (
//                       <div className="order-info">
//                         Returned At
//                         <div className="order-info">
//                           <span>
//                             {
//                               new Date(item?.Order_History?.returnedAt)
//                                 .toISOString()
//                                 .split("T")[0]
//                             }
//                             {formatTimeInIST(item?.Order_History?.returnedAt)}{" "}
//                             IST
//                           </span>
//                         </div>
//                       </div>
//                     )}

//                     {item?.Order_History?.refundedAt && (
//                       <div className="order-info">
//                         Refunded At
//                         <div className="order-info">
//                           <span>
//                             {
//                               new Date(item?.Order_History?.refundedAt)
//                                 .toISOString()
//                                 .split("T")[0]
//                             }
//                             {formatTimeInIST(item?.Order_History?.refundedAt)}{" "}
//                             IST
//                           </span>
//                         </div>
//                       </div>
//                     )}
//                   </td>
//                   {/* <td>
//                   {!item?.Return_Order ? (
//                     <>
//                       {item?.delivery_boy ? (
//                         <>
//                           <div className="my-1">
//                             <Button className="action-btn active">
//                               {" "}
//                               {item?.delivery_boy?.name}
//                             </Button>
//                           </div>
//                         </>
//                       ) : item?.Store_Detail?.s_category?.is_restaurant_flow ? (
//                         <>
//                           {" "}
//                           {item?.order_status_id ===
//                             OrderStatusIds.Processing &&
//                             user?.role_id === RoleId.Vendor && (
//                               <>
//                                 {item?.service_id == ServiceIds.Delivery ||
//                                 item?.service_id == ServiceIds.RoomService ? (
//                                   <div className="my-1">
//                                     <Button
//                                       className="action-btn active"
//                                       onClick={() =>
//                                         setShowAssign({
//                                           show: item?.id,
//                                           data: item?.User_Address,
//                                         })
//                                       }
//                                     >
//                                       {" "}
//                                       Assign Delivery Boy{" "}
//                                     </Button>
//                                   </div>
//                                 ) : (
//                                   <div className="my-1">
//                                     <Button
//                                       className="action-btn active"
//                                       onClick={() =>
//                                         ChangeOrderStatus(
//                                           item?.id,
//                                           OrderStatusIds.PickupSchedued
//                                         )
//                                       }
//                                     >
//                                       {" "}
//                                       Cooked{" "}
//                                     </Button>
//                                   </div>
//                                 )}
//                               </>
//                             )}
//                         </>
//                       ) : (
//                         <>
//                           {item?.order_status_id ===
//                             OrderStatusIds.Processing &&
//                             user?.role_id === RoleId.Vendor && (
//                               <div className="my-1">
//                                 <Button
//                                   className="action-btn active"
//                                   onClick={() =>
//                                     setShowAssign({
//                                       show: item?.id,
//                                       data: item?.User_Address,
//                                     })
//                                   }
//                                 >
//                                   {" "}
//                                   Assign Delivery Boy{" "}
//                                 </Button>
//                               </div>
//                             )}

//                           {item?.Return_Order?.return_reason_id ===
//                             ReturnStatusIds.ReturnRequested &&
//                             user?.role_id === RoleId.Vendor && (
//                               <div className="my-1">
//                                 <Button
//                                   className="action-btn active"
//                                   onClick={() =>
//                                     setShowReturnAssign({
//                                       show: item?.id,
//                                       data: item?.User_Address,
//                                     })
//                                   }
//                                 >
//                                   {" "}
//                                   Assign Delivery Boy{" "}
//                                 </Button>
//                               </div>
//                             )}
//                         </>
//                       )}
//                     </>
//                   ) : (
//                     <>
//                       {item?.Return_Order?.User ? (
//                         <>
//                           <div className="my-1">
//                             <Button className="action-btn active">
//                               {" "}
//                               {item?.Return_Order?.User?.name}
//                             </Button>
//                           </div>
//                         </>
//                       ) : item?.Store_Detail?.s_category?.is_restaurant_flow ? (
//                         <>
//                           {" "}
//                           {item?.Return_Order?.return_status_id ===
//                             ReturnStatusIds.ReturnRequested &&
//                             user?.role_id === RoleId.Vendor && (
//                               <>
//                                 {item?.service_id == ServiceIds.Delivery ||
//                                 item?.service_id == ServiceIds.RoomService ? (
//                                   <div className="my-1">
//                                     <Button
//                                       className="action-btn active"
//                                       onClick={() =>
//                                         setShowAssign({
//                                           show: item?.id,
//                                           data: item?.User_Address,
//                                         })
//                                       }
//                                     >
//                                       {" "}
//                                       Assign Delivery Boy{" "}
//                                     </Button>
//                                   </div>
//                                 ) : (
//                                   <div className="my-1">

//                                   </div>
//                                 )}
//                               </>
//                             )}
//                         </>
//                       ) : (
//                         <>
//                           {item?.Return_Order?.return_status_id ===
//                             ReturnStatusIds.ReturnRequested &&
//                             user?.role_id === RoleId.Vendor && (
//                               <div className="my-1">
//                                 <Button
//                                   className="action-btn active"
//                                   onClick={() =>
//                                     setShowReturnAssign({
//                                       show: item?.id,
//                                       data: item?.User_Address,
//                                     })
//                                   }
//                                 >
//                                   {" "}
//                                   Assign Delivery Boy{" "}
//                                 </Button>
//                               </div>
//                             )}
//                         </>
//                       )}
//                     </>
//                   )}

//                 </td> */}
//                 </tr>
//               ))}
//             </tbody>
//           </Table>
//           {data && data?.data?.data?.length > 0 ? (
//             <Pagination_Holder
//               onPageChange={currentPage}
//               totalPages={totalPages}
//               handlePageChange={handlePageChange}
//             />
//           ) : (
//             <p className="no-datashow">Sorry, No Data Found</p>
//           )}
//         </div>
//       )}
//       <AssignOffCanvance
//         handleClose={() => {
//           setShowAssign({ show: 0, data: {} });
//           getDataAll();
//         }}
//         setShow={() => setShowAssign({ show: 0, data: {} })}
//         show={showAssign?.show}
//         data={showAssign?.data}
//       />
//       <AssignReturnOffCanvance
//         handleClose={() => {
//           setShowReturnAssign({ show: 0, data: {} });
//           getDataAll();
//         }}
//         setShow={() => setShowReturnAssign({ show: 0, data: {} })}
//         show={showReturnAssign?.show}
//         data={showReturnAssign?.data}
//       />
//       <ProductModal
//         handleClose={() => {
//           setShowDetails({ show: 0, data: {} });
//         }}
//         setShow={() => setShowDetails({ show: 0, data: {} })}
//         show={showDetails?.show}
//         data={showDetails?.data}
//       />
//     </section>
//   );
// }

// export default CancelledTable;

import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  formatDate,
  formatTo12Hour,
  IDS,
  OrderStatusIds,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";
import AssignOffCanvance from "../AssignDeliveryBoy";
import ProductModal from "../ProductModal";
import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
import DatePicker from "react-datepicker";
import search1 from "../../../assets/icons/search.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function CancelledTable({
  user,
  OrderByOptions,

  storeCategories,

  productCategories,

  vendorServices,
  resultsPerPageOptions,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);

  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();

  const [storeCategory, setStoreCategory] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [search, setSearch] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");

  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();
  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });
  const [searchCustomerContact, setSearchCustomerContact] = useState("");
  const [loading, setLoading] = useState(false);

  const getDataAll = async () => {
    setLoading(true);

    const response = await getData(
      `/admin/orders/cancel-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&term=${search}&searchOrderStatus=${
        OrderStatusIds.Rejected || ""
      }&productCategory=${
        productCategory.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&name=${search || ""}&customer=${searchCustomer || ""}&customer_contact=${searchCustomerContact || ""}`,
    );
    await setData(response);
    if (response?.success) {
      setLoading(false);
    }
    setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    // await GetAllCounts();
  };
  useEffect(() => {
    getDataAll();
  }, [reset, searchOrderStatus, productCategory, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const ChangeOrderStatus = async (id, status_id) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/orders/product-order/update-status/${id}`, {
        order_status_id: status_id,
      });

      // Refresh the data after updating the store's status
      await getDataAll();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        // await DownloadExcel(
        //   // "/download-excel/download-users",
        //   `/download-excel/download-users?term=${search || ""}&mobile=${mobile || ""}&from=${from || ""}&to=${to || ""}`,
        //   "Users List"
        // );
        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 25
          }&term=${search}&searchOrderStatus=${
            OrderStatusIds.Rejected || ""
          }&storeCategory=${storeCategory}&productCategory=${
            productCategory || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }`,
          null,
          "Subscription Order List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  return (
    <section className="pending-table_holder">
      {/* Quick Filters Section */}
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row align-items-end mb-3">
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  min="1900-01-01"
                  max="2099-12-31"
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  min={searchDateFrom}
                  max="2099-12-31"
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Allow only if year is 4 digits or input is empty
                    if (year.length === 4 || value === "") {
                      setSearchDateTo(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                placeholder="Enter Product Name"
                type="text"
                className="form-control"
                id=""
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Customer Contact No</Form.Label>
              <Form.Control
                placeholder="Enter Customer Contact No"
                type="text"
                className="form-control"
                id=""
                value={searchCustomerContact}
                onChange={(e) => {
                  setSearchCustomerContact(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
              <div className="Search me-2">
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  Search
                </Button>
              </div>
              <div className="Search-1">
                <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchEndTime("");
                    setSearchStartTime("");
                    setSearchCustomer("");
                    setSearchCustomerContact("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Order Date</th>
              <th>Order details</th>

              <th>Products</th>
              <th style={{ width: "220px" }}>Total</th>
              <th>Delivery Details</th>
              <th>Order Status</th>
              {/* <th>Action</th> */}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="8" className="text-center py-5">
                  <div className="d-flex justify-content-center align-items-center">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                      style={{ width: "3rem", height: "3rem" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>

                  <div className="mt-2">Loading orders...</div>
                </td>
              </tr>
            ) : (
              data?.data?.data?.map((item, index) => (
                <tr key={index}>
                  <td className="order-details">{index + 1}</td>
                  <td className="order-date">
                    <div className="order-id">
                      {calculateTimeAgo(item?.createdAt)}
                    </div>
                    <div className="order-info">
                      <span>
                        {new Date(item?.createdAt).toISOString().split("T")[0]}
                      </span>
                    </div>
                    <div className="order-info">
                      <span>{formatTimeInIST(item?.createdAt)} IST</span>
                    </div>
                  </td>

                  {/* Owner Details */}
                  <td className="order-details">
                    <div className="order-id text-highlight">
                      {item?.Product_Order?.invoice_no}
                    </div>
                    <div className="order-info">
                      <span>
                        <b>Buyer Name</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span className="text-highlight">
                        {item?.Product_Order?.User?.name}
                      </span>
                    </div>
                    <div className="order-info">
                      <span className="order-info">
                        <span>
                          <b>No.</b>
                        </span>
                        {item?.Product_Order?.User?.contact_no}
                      </span>
                    </div>

                    <div className="order-info">
                      <span>{item?.Product_Order?.Payment_Type?.name}</span>
                    </div>

                    {/* <div className="order-info">
                    <span>{item?.user?.type}</span>
                  </div> */}
                  </td>

                  <td className="order-details">
                    {" "}
                    <div className="index_div">
                      {" "}
                      <p className="index_no">{1}) </p>
                      <div className="all_data">
                        {" "}
                        <div className="text-highlight">
                          {" "}
                          <span>
                            {" "}
                            <b>Product Name</b>{" "}
                          </span>{" "}
                          : <span>{item?.Product?.name}</span>{" "}
                        </div>{" "}
                        <div className="order-info">
                          {" "}
                          <span>
                            {" "}
                            <b>Category Name</b>{" "}
                          </span>{" "}
                          : <span>{item?.Product?.p_category?.name}</span>{" "}
                        </div>{" "}
                      </div>{" "}
                    </div>{" "}
                    <div></div>{" "}
                    {/* <div className="mt-3"> <Button className="action-btn active" onClick={() => setShowDetails({ show: item?.id, data: item?.Product_Order_Details, }) } > View All Details </Button> </div> */}{" "}
                  </td>

                  <td className="order-details more_space">
                    <div className="order-id">
                      <span>
                        <b>Total SubTotal</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_selling_price).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Packing Charges</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.packing_charges} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Delivery Charges</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.delivery_charges).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>
                      <b>Offer Discount</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>{item.Exchange_Rate?.symbol || "₹"}{" "}{Number(item?.offer_discount).toFixed(2)} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Coupon Discount</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.coupon_discount).toFixed(2)} /-
                      </span>
                    </div>
                    <div className="order-id">
                      <span>
                        <b>Total Tax</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_tax).toFixed(2)} /-
                      </span>
                    </div>
                    <div className="order-id">
                      <span>
                        <b>Grand Total</b>
                      </span>
                    </div>
                    <div className="text-highlight">
                      <span>
                        {item.Exchange_Rate?.symbol || "₹"}{" "}
                        {Number(item?.total_amount).toFixed(2)} /-
                      </span>
                    </div>
                  </td>

                  <td>
                    <>
                      <div className="text-highlight">
                        <span>
                          {item?.Product_Order?.User_Address?.first_name}{" "}
                          {item?.Product_Order?.User_Address?.last_name}
                        </span>
                      </div>
                      <div className="order-info">
                        <span>
                          {item?.Product_Order?.User_Address?.floor} floor ,
                        </span>
                        <span>
                          {item?.Product_Order?.User_Address?.building},{" "}
                        </span>
                        <span>
                          {item?.Product_Order?.User_Address?.apartment} ,
                        </span>
                        <span>
                          {item?.Product_Order?.User_Address?.street},{" "}
                        </span>
                      </div>
                      <div className="order-info">
                        <span>
                          {
                            item?.Product_Order?.User_Address
                              ?.Users_Address_Detail?.Country?.name
                          }{" "}
                          ,
                        </span>
                        <span>
                          {
                            item?.Product_Order?.User_Address
                              ?.Users_Address_Detail?.State?.name
                          }
                          ,{" "}
                        </span>
                        <span>
                          {
                            item?.Product_Order?.User_Address
                              ?.Users_Address_Detail?.City?.name
                          }{" "}
                          ,
                        </span>
                        <span>
                          {
                            item?.Product_Order?.User_Address
                              ?.Users_Address_Detail?.Area?.name
                          }
                          ,{" "}
                        </span>
                        <span>
                          {
                            item?.Product_Order?.User_Address
                              ?.Users_Address_Detail?.Pincode?.name
                          }
                          ,{" "}
                        </span>
                      </div>
                      <div className="order-info">
                        <span>
                          {item?.Product_Order?.User_Address?.address_type}
                        </span>
                      </div>
                      <div className="text-highlight">
                        <span>
                          {item?.Product_Order?.User_Address?.contact_no}{" "}
                        </span>
                      </div>

                      <div className="order-info">
                        <span>
                          <b>Cancel Message</b>
                        </span>{" "}
                        :{" "}
                        <span>
                          {item?.Product_Order?.Order_Cancellation?.message}
                        </span>
                      </div>
                      <div className="text-highlight">
                        <span>
                          <b>Cancel Reason</b>
                        </span>{" "}
                        :
                        <span>
                          {
                            item?.Product_Order?.Order_Cancellation
                              ?.Cancel_Reason?.name
                          }{" "}
                        </span>
                      </div>
                    </>
                  </td>

                  <td>
                    <div>
                      <p className="status-holder Unshipped">Rejected</p>
                    </div>
                    {/* {item?.order_status_id === 4 ? (
                    <div>
                      <p className="status-holder shipped">
                        {item?.Order_status?.name}
                      </p>
                    </div>
                  ) : (
                   
                  )} */}

                    {item?.Order_History?.delivery_boy_assigned && (
                      <div className="order-info">
                        Delivery Boy Asigned At
                        <div className="order-info">
                          <span>
                            {
                              new Date(
                                item?.Order_History?.delivery_boy_assigned,
                              )
                                .toISOString()
                                .split("T")[0]
                            }
                            {formatTimeInIST(
                              item?.Order_History?.delivery_boy_assigned,
                            )}{" "}
                            IST
                          </span>
                        </div>
                      </div>
                    )}

                    {item?.Order_History?.out_for_delivery && (
                      <div className="order-info">
                        Out For Delivery At
                        <div className="order-info">
                          <span>
                            {
                              new Date(item?.Order_History?.out_for_delivery)
                                .toISOString()
                                .split("T")[0]
                            }
                            {formatTimeInIST(
                              item?.Order_History?.out_for_delivery,
                            )}{" "}
                            IST
                          </span>
                        </div>
                      </div>
                    )}

                    {/* {item?.Order_History?.cancelledAt && ( */}
                    <div className="order-info">
                      Cancelled At
                      <div className="order-info">
                        <span>
                          {
                            new Date(item?.updatedAt)
                              .toISOString()
                              .split("T")[0]
                          }{" "}
                          <br />
                          {formatTimeInIST(item?.updatedAt)} IST
                        </span>
                      </div>
                    </div>
                    {/* )} */}

                    {item?.Order_History?.returnRequestedAt && (
                      <div className="order-info">
                        Return Requested At
                        <div className="order-info">
                          <span>
                            {
                              new Date(item?.Order_History?.returnRequestedAt)
                                .toISOString()
                                .split("T")[0]
                            }
                            {formatTimeInIST(
                              item?.Order_History?.returnRequestedAt,
                            )}{" "}
                            IST
                          </span>
                        </div>
                      </div>
                    )}

                    {item?.Order_History?.returnScheduledAt && (
                      <div className="order-info">
                        Return Scheduled At
                        <div className="order-info">
                          <span>
                            {
                              new Date(item?.Order_History?.returnScheduledAt)
                                .toISOString()
                                .split("T")[0]
                            }
                            {formatTimeInIST(
                              item?.Order_History?.returnScheduledAt,
                            )}{" "}
                            IST
                          </span>
                        </div>
                      </div>
                    )}

                    {item?.Order_History?.itemPickedAt && (
                      <div className="order-info">
                        Item Picked At
                        <div className="order-info">
                          <span>
                            {
                              new Date(item?.Order_History?.itemPickedAt)
                                .toISOString()
                                .split("T")[0]
                            }
                            {formatTimeInIST(item?.Order_History?.itemPickedAt)}{" "}
                            IST
                          </span>
                        </div>
                      </div>
                    )}

                    {item?.Order_History?.returnedAt && (
                      <div className="order-info">
                        Returned At
                        <div className="order-info">
                          <span>
                            {
                              new Date(item?.Order_History?.returnedAt)
                                .toISOString()
                                .split("T")[0]
                            }
                            {formatTimeInIST(item?.Order_History?.returnedAt)}{" "}
                            IST
                          </span>
                        </div>
                      </div>
                    )}

                    {item?.Order_History?.refundedAt && (
                      <div className="order-info">
                        Refunded At
                        <div className="order-info">
                          <span>
                            {
                              new Date(item?.Order_History?.refundedAt)
                                .toISOString()
                                .split("T")[0]
                            }
                            {formatTimeInIST(item?.Order_History?.refundedAt)}{" "}
                            IST
                          </span>
                        </div>
                      </div>
                    )}
                  </td>
                  {/* <td>
                  {!item?.Return_Order ? (
                    <>
                      {item?.delivery_boy ? (
                        <>
                          <div className="my-1">
                            <Button className="action-btn active">
                              {" "}
                              {item?.delivery_boy?.name}
                            </Button>
                          </div>
                        </>
                      ) : item?.Store_Detail?.s_category?.is_restaurant_flow ? (
                        <>
                          {" "}
                          {item?.order_status_id ===
                            OrderStatusIds.Processing &&
                            user?.role_id === RoleId.Vendor && (
                              <>
                                {item?.service_id == ServiceIds.Delivery ||
                                item?.service_id == ServiceIds.RoomService ? (
                                  <div className="my-1">
                                    <Button
                                      className="action-btn active"
                                      onClick={() =>
                                        setShowAssign({
                                          show: item?.id,
                                          data: item?.User_Address,
                                        })
                                      }
                                    >
                                      {" "}
                                      Assign Delivery Boy{" "}
                                    </Button>
                                  </div>
                                ) : (
                                  <div className="my-1">
                                    <Button
                                      className="action-btn active"
                                      onClick={() =>
                                        ChangeOrderStatus(
                                          item?.id,
                                          OrderStatusIds.PickupSchedued
                                        )
                                      }
                                    >
                                      {" "}
                                      Cooked{" "}
                                    </Button>
                                  </div>
                                )}
                              </>
                            )}
                        </>
                      ) : (
                        <>
                          {item?.order_status_id ===
                            OrderStatusIds.Processing &&
                            user?.role_id === RoleId.Vendor && (
                              <div className="my-1">
                                <Button
                                  className="action-btn active"
                                  onClick={() =>
                                    setShowAssign({
                                      show: item?.id,
                                      data: item?.User_Address,
                                    })
                                  }
                                >
                                  {" "}
                                  Assign Delivery Boy{" "}
                                </Button>
                              </div>
                            )}

                          {item?.Return_Order?.return_reason_id ===
                            ReturnStatusIds.ReturnRequested &&
                            user?.role_id === RoleId.Vendor && (
                              <div className="my-1">
                                <Button
                                  className="action-btn active"
                                  onClick={() =>
                                    setShowReturnAssign({
                                      show: item?.id,
                                      data: item?.User_Address,
                                    })
                                  }
                                >
                                  {" "}
                                  Assign Delivery Boy{" "}
                                </Button>
                              </div>
                            )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {item?.Return_Order?.User ? (
                        <>
                          <div className="my-1">
                            <Button className="action-btn active">
                              {" "}
                              {item?.Return_Order?.User?.name}
                            </Button>
                          </div>
                        </>
                      ) : item?.Store_Detail?.s_category?.is_restaurant_flow ? (
                        <>
                          {" "}
                          {item?.Return_Order?.return_status_id ===
                            ReturnStatusIds.ReturnRequested &&
                            user?.role_id === RoleId.Vendor && (
                              <>
                                {item?.service_id == ServiceIds.Delivery ||
                                item?.service_id == ServiceIds.RoomService ? (
                                  <div className="my-1">
                                    <Button
                                      className="action-btn active"
                                      onClick={() =>
                                        setShowAssign({
                                          show: item?.id,
                                          data: item?.User_Address,
                                        })
                                      }
                                    >
                                      {" "}
                                      Assign Delivery Boy{" "}
                                    </Button>
                                  </div>
                                ) : (
                                  <div className="my-1">
                                   
                                  </div>
                                )}
                              </>
                            )}
                        </>
                      ) : (
                        <>
                          {item?.Return_Order?.return_status_id ===
                            ReturnStatusIds.ReturnRequested &&
                            user?.role_id === RoleId.Vendor && (
                              <div className="my-1">
                                <Button
                                  className="action-btn active"
                                  onClick={() =>
                                    setShowReturnAssign({
                                      show: item?.id,
                                      data: item?.User_Address,
                                    })
                                  }
                                >
                                  {" "}
                                  Assign Delivery Boy{" "}
                                </Button>
                              </div>
                            )}
                        </>
                      )}
                    </>
                  )}

                  
                </td> */}
                </tr>
              ))
            )}
          </tbody>
        </Table>
        {data && data?.data?.data?.length > 0 ? (
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        ) : (
          <p className="no-datashow">Sorry, No Data Found</p>
        )}
      </div>
      <AssignOffCanvance
        handleClose={() => {
          setShowAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowAssign({ show: 0, data: {} })}
        show={showAssign?.show}
        data={showAssign?.data}
      />
      <AssignReturnOffCanvance
        handleClose={() => {
          setShowReturnAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowReturnAssign({ show: 0, data: {} })}
        show={showReturnAssign?.show}
        data={showReturnAssign?.data}
      />
      <ProductModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />
    </section>
  );
}

export default CancelledTable;
